import { render, staticRenderFns } from "./cModalOtrosIngresos.vue?vue&type=template&id=1ffd35f0&scoped=true"
import script from "./cModalOtrosIngresos.vue?vue&type=script&lang=js"
export * from "./cModalOtrosIngresos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd35f0",
  null
  
)

export default component.exports